import React from 'react';
import Icon from '../../../components/AppIcon';
import EmptyState from '../../../components/ui/EmptyState';

// Report history is currently empty — reports will appear here once generated
const DEMO_HISTORY = [];

const typeConfig = {
  compliance: { label: 'Compliance', color: 'bg-emerald-100 text-emerald-700', icon: 'Shield' },
  audit_pack: { label: 'Audit Pack', color: 'bg-slate-100 text-slate-700', icon: 'Package' },
  worker_performance: { label: 'Performance', color: 'bg-blue-100 text-blue-700', icon: 'Users' },
  progress: { label: 'Progress', color: 'bg-purple-100 text-purple-700', icon: 'TrendingUp' },
};

const ReportHistory = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="History" size={16} className="text-muted-foreground" />
        <h2 className="text-sm font-semibold text-foreground font-heading">Recent Reports</h2>
      </div>

      {DEMO_HISTORY?.length === 0 ? (
        <EmptyState
          icon="FileBarChart"
          title="No reports yet"
          description="Generate your first report using the builder on the left."
          className="py-6"
        />
      ) : (
        <div className="space-y-2">
          {DEMO_HISTORY?.map(report => {
            const config = typeConfig?.[report?.type] || typeConfig?.compliance;
            return (
              <div
                key={report?.id}
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors cursor-pointer group"
              >
                <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
                  <Icon name={report?.format === 'PDF' ? 'FileText' : 'Table'} size={14} className="text-muted-foreground" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium text-foreground truncate">{report?.name}</p>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${config?.color}`}>
                      {config?.label}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      {new Date(report?.date)?.toLocaleDateString('en-GB')}
                    </span>
                    <span className="text-xs text-muted-foreground">{report?.size}</span>
                  </div>
                </div>
                <button className="opacity-0 group-hover:opacity-100 transition-opacity p-1.5 rounded hover:bg-muted">
                  <Icon name="Download" size={13} className="text-muted-foreground" />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ReportHistory;
